<script setup>
import github from "@/assets/img/github.svg";
import google from "@/assets/img/google.svg";
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import registerBg2 from "@/assets/img/register_bg_2.png";
import {ElLoading} from "element-plus";
import {ref} from "vue";
import {inject} from 'vue'

const $axios = inject('$axios')


function download(filename) {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true
  })
  $axios({
    url: `http://bioinfo-gdut.com:8000/api/download`,
    method: 'post',
    params: {
      file: filename,
    },
    responseType: 'blob' // 表明返回服务器返回的数据类型
  }).then(resp => {
    loadingInstance.close()
    var res = JSON.parse(JSON.stringify(resp.headers))
    if (res['content-type'] === 'application/zip') {
      let url = window.URL.createObjectURL(new Blob([resp.data], {type: "application/zip;charset=utf-8"}));
      const link = document.createElement("a");
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      console.log(url)
    } else {
      fullscreenLoading.value = false
      ElMessage({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: '<p>Sorry,Some samples are missing corresponding data.</p>',
        type: 'error',
        center: true,
      })
    }
  })

}
</script>
<template>
  <div>
    <IndexNavbar/>
    <main>
      <section class="relative w-full h-full py-40 min-h-screen">
        <div
            class="absolute top-0 w-full h-full  bg-no-repeat bg-full"

        ></div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-12/12 px-4">
              <div
                  class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
              >
                <div class="rounded-t mb-0 px-6 py-6">

                  <div class="text-center my-3">
              <span class="text-blueGray-500 text-lg font-bold" style="font-size:35px">
                Download
              </span>
                  </div>
                  <div class="col-12">
                    <table class="table table-striped table-md align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <tbody>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Gene Expression Matrix
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <button
                              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              @click="download('Annotation')">
                            Downloading
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Knowledge Graph Node Data
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <button
                              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              @click="download('Expression_quantity')">
                            Downloading
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Knowledge Graph Relationship Data
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <button
                              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              @click="download('Figure')">
                            Downloading
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Differential Analysis
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <button
                              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              @click="download('Sequence')">
                            Downloading
                          </button>
                        </td>
                      </tr>
<!--                      <tr>-->
<!--                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">-->
<!--                          TPS_Sequence-->
<!--                        </td>-->
<!--                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">-->
<!--                          <button-->
<!--                              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
<!--                              type="button"-->
<!--                              @click="download('TPS_Sequence')">-->
<!--                            Downloading-->
<!--                          </button>-->
<!--                        </td>-->
<!--                      </tr>-->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer-component/>
      </section>
    </main>
  </div>
</template>
